<div class="chart-card">
  <div>
    <div id="chart"></div>
    <br />

    <svg
      id="my_dataviz1"
      width="100%"
      viewBox="0 0 450 550"
      preserveAspectRatio="xMidYMid meet"
    ></svg>
   
    <!-- <defs>
        <pattern id="chloroplethbackground" patternUnits="userSpaceOnUse" width="??" height="??">
            <image xlink:href="../../../assets/images/map-background.png" x="0" y="0"
             width="??" height="??" />
        </pattern>
    </defs> -->
  </div>
  <div id="map">
    <div id="select"></div>
  </div>
</div>
